if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];
      constructor() {
        super();
        this.fontSizeNumber = 30;
        this.fontSizeText = "30px";
        if(window.innerWidth < 767){
          this.fontSizeNumber = 20;
          this.fontSizeText = "20px";
        }
        this.quantityInput = this.querySelector('.quantity__input');
        this.engravingInputChange = this.querySelector('#embros_txt');
        this.textWrapper = this.querySelector('#toChange');
        this.engravingText = this.querySelector('#toChange p')
        this.fontFamilySelectors = this.querySelectorAll(".font-familt-grid input");
        if (this.fontFamilySelectors) {
          this.fontFamilySelectors.forEach(input => input.addEventListener('change', this.handleFontFamilySelectors.bind(this)));
        }
        if (this.engravingInputChange) {
          this.engravingInputChange.addEventListener('keyup', this.handleEngravingInputChange.bind(this));
        }
        this.protectionLabels = document.querySelectorAll('.product-clarity-commitment .protection-plan-wrapper label');
        this.lifetimeInfo = document.querySelector('.product-clarity-commitment .lifetime-info');
        this.protectionLabels.forEach((label) => {
          label.addEventListener('click', this.handleProtectionLabelClick.bind(this));
        });
      }
      handleProtectionLabelClick(event) {
        const closestDiv = event.target.closest('.grid__item');
        const protectionInput = closestDiv?.querySelector('input');
        if (protectionInput?.checked) {
          event.preventDefault();
          protectionInput.checked = false;
          protectionInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      protection_price_range(variant_price) {
        try {
          const is_bridal_product = theme.is_bridal;
          let protection_variant_list;
          if (is_bridal_product) {
            protection_variant_list = theme.protection_product_lifetime;
          } else {
            protection_variant_list = theme.protection_product_3y;
            const option1 = document.getElementById("product-input-option-1");
            const option2 = document.getElementById("product-input-option-2");
            if (option1) option1.value = "1 Year";
            if (option2) option2.value = "2 Year";
            const year1 = document.querySelector(".product-protection-option-1 .update-year");
            const year2 = document.querySelector(".product-protection-option-2 .update-year");
            const sup = document.querySelector(".product-protection-option-2 sup");
            if (year1) year1.textContent = "1 Year";
            if (year2) year2.textContent = "2 Year";
            if (sup) sup.style.display = "none";
          }
          let price_range = "";
          for (const obj in protection_variant_list) {
            const lower_price_range = obj.split(" / ")[1].split("-")[0] * 100;
            const higher_price_range = obj.split(" / ")[1].split("-")[1] * 100;
            if (variant_price >= lower_price_range && variant_price <= higher_price_range) {
              price_range = obj.split(" / ")[1];
              break;
            }
          }
          if (!price_range.length) {
            document.querySelector(".product-clarity-commitment")?.style.setProperty("display", "none");
            document.querySelectorAll(".product-clarity-commitment .protection-plan-wrapper input").forEach((input) => {
              input.checked = false;
            });
            return false;
          }
          document.querySelector(".product-clarity-commitment")?.style.removeProperty("display");
          if (is_bridal_product) {
            return [
              ...protection_variant_list[`3 / ${price_range}`],
              ...protection_variant_list[`Lifetime / ${price_range}`],
            ];
          }
          return [
            ...protection_variant_list[`1 / ${price_range}`],
            ...protection_variant_list[`2 / ${price_range}`],
          ];
        } catch (e) {
          console.log(e);
          return false;
        }
      }
      variant_update_protection_price(data) {
        try {
          const result = this.protection_price_range(data);
          console.log("variant_update_protection_price",result);
          if (!result) return;
          const [price_option1, variant_option1, price_option2, variant_option2] = result;
          const option1 = document.querySelector(".product-protection-option-1");
          const option2 = document.querySelector(".product-protection-option-2");
          if (option1) {
            option1.setAttribute("data-protection-id", variant_option1);
            const priceEl = option1.querySelector("p .update-price");
            if (priceEl) priceEl.textContent = theme.Currency.formatMoney(price_option1, theme.moneyFormat);
          }
          if (option2) {
            option2.setAttribute("data-protection-id", variant_option2);
            const priceEl = option2.querySelector("p .update-price");
            if (priceEl) priceEl.textContent = theme.Currency.formatMoney(price_option2, theme.moneyFormat);
          }
        } catch (e) {
          console.log(e);
        }
      }

      connectedCallback() {
        this.initializeProductSwapUtility();
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );
        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
        const selector = 'product-info';
        const variant = this.getSelectedVariant(document.querySelector(selector));
        if (variant) {
          const variantPrice = Math.max(variant.price, variant.compare_at_price || 0);
          this.variant_update_protection_price(variantPrice);
          this.updateVariantMetaField(variant);
        }
      }
      decreaseFontSize(textWrapperParaWidth){
        let textWrapperWidth = this.textWrapper.clientWidth;
        let fontSize = this.fontSizeNumber;
        while (textWrapperParaWidth > textWrapperWidth) {
          fontSize--;
          this.engravingText.style.fontSize = `${fontSize}px`;
          textWrapperParaWidth = this.engravingText.clientWidth;
          if (textWrapperParaWidth <= textWrapperWidth){
            break;
          }; // Prevents excessive shrinking
        }
      }
      updateFontSize(){
        let textWrapperParaWidth = this.engravingText.clientWidth;
        const fontSize = window.getComputedStyle(this.engravingText).fontSize;
        this.decreaseFontSize(textWrapperParaWidth);
        if(fontSize != this.fontSizeText){
          this.engravingText.style.fontSize = this.fontSizeText;
          textWrapperParaWidth = this.engravingText.clientWidth;
          this.decreaseFontSize(textWrapperParaWidth);
        }
      }
      handleFontFamilySelectors(event) {
        // Update the selected font family
        const selectedFontFamily = event.target.value;
        this.textWrapper.style.fontFamily = selectedFontFamily;
        this.querySelector(".font_btn_head span").innerText = selectedFontFamily;
        this.updateFontSize();
      }
      handleEngravingInputChange(event){
        var inputValue = event.target.value;
        this.engravingText.innerText = inputValue;
        this.querySelector(".engraving_heading span").innerText = inputValue;
        this.updateFontSize();
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;
        console.log(target.getAttribute('name'));
        if(target.getAttribute('name') && target.getAttribute('name').includes('custom-ring-size')) return false;
        this.resetProductFormState();
        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        console.log(productUrl);
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = JSON.parse(productInfoNode.querySelector('[data-selected-variant]')?.innerHTML);
        var selectedList = this.querySelector('.product-form__variants');
        var selectedVariantAvailable = selectedList.querySelector(`[data-variant="${selectedVariant.id}"]`).dataset.variantAvailable;
        var selectedVariantInventoryQuantity = selectedList.querySelector(`[data-variant="${selectedVariant.id}"]`).dataset.variantQty;
        var selectedVariantInventoryPolicy = selectedList.querySelector(`[data-variant="${selectedVariant.id}"]`).dataset.inventory_policy;
        window.estimatedShippingDate(selectedVariantAvailable,selectedVariantInventoryQuantity,selectedVariantInventoryPolicy);
        return !!selectedVariant ? selectedVariant : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);
          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id,variant);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      loadVariant360(activeVariant360Selector){
        const existingIframe = activeVariant360Selector.querySelector("iframe"); 
        if(!existingIframe) {
          const iframeSrc = activeVariant360Selector.querySelector(".iframe-360-view").dataset.iframe
          const iframe = document.createElement("iframe");
          iframe.src = iframeSrc;
          iframe.setAttribute("allowfullscreen", "");
          iframe.setAttribute("frameborder", "0");  
          iframe.setAttribute("scrolling", "no");   
          activeVariant360Selector.appendChild(iframe);
        }
      }

      updateVariantImage(variant){
        console.log(variant); 
        if(theme.productTags.includes('galaxy-star') || theme.productTags.includes('forever-star')){
          var selectedList = this.querySelector('.product-form__variants');
          var imageHandle = selectedList.querySelector(`[data-variant="${variant.id}"]`).dataset.variantHandle;
          if (selectedList){
            if(imageHandle){
              document.querySelectorAll('.product__media-item:not(.all)').forEach(function(div){
                div.classList.remove('is-active',"swiper-slide");
                const fancyboxSelector = div.querySelector(".product-media")
                fancyboxSelector.hasAttribute("data-fancybox") && (div.querySelector(".product-media").dataset.fancybox = "")
              });
              document.querySelectorAll(`.${imageHandle}`).forEach(function(div){
                div.classList.add('is-active',"swiper-slide");
                const fancyboxSelector = div.querySelector(".product-media")
                fancyboxSelector.hasAttribute("data-fancybox") && (div.querySelector(".product-media").dataset.fancybox = "gallery")
              });
            }
            publish(PUB_SUB_EVENTS.variantData, {variant,imageHandle});
          } else {
            publish(PUB_SUB_EVENTS.variantData, {variant,imageHandle});
          };
        }
      }

      hideShippingMessage(isAvailable){
        var shippingMessage = document.querySelector('.shipping-delivery-msg');
        if(!isAvailable){
          shippingMessage.classList.add('hidden');
        } else {
          shippingMessage.classList.remove('hidden');
        }
      }

      updateVariantMetaField(variant){
        const variantMetaField = document.querySelector('#product-variant-meta-filed');
        const variantMetaFieldData = JSON.parse(variantMetaField.innerHTML);
        const center_stone_weight = variantMetaFieldData[variant.id]?.center_stone_weight;
        const metalType = variantMetaFieldData[variant.id]?.metal_color;
        if(center_stone_weight){
          const center_diamond_weight = document.querySelector('.center-stone-weight-text');
          if(center_diamond_weight){
            center_diamond_weight.innerHTML = center_stone_weight;
          }
        }
        if(metalType){
          const metalTypeText = document.querySelector('.metal-type-text');
          if(metalTypeText){
            metalTypeText.innerHTML = metalType;
          }
        }
        if(variant.option3){
          const totalDiamondWeightText = document.querySelector('.total-diamond-weight-text');
          if(totalDiamondWeightText){
            totalDiamondWeightText.innerHTML = variant.option3;
          }
        }
      }
      updateAffirmPrice(variant){
        this.hideShippingMessage(variant.available);
        const variantPrice = variant.price;
        const comparePrice = variant.compare_at_price || 0;
        this.variant_update_protection_price(comparePrice > variantPrice ? comparePrice : variantPrice);
        const affirmPrice = document.querySelector('.affirm-as-low-as');
        affirmPrice.dataset.amount = variantPrice;
        try{
          affirm.ui.refresh();
        } catch(e){
          console.log(e);
        }
        const points = variantPrice * 0.01;
        const pointsText = document.querySelector('.stamped-badge__text span');
        if(pointsText){
          pointsText.innerHTML = `${points}`;
        }
      }

      updateMedia(html, variantFeaturedMediaId,variant) {
        this.updateAffirmPrice(variant);
        this.updateVariantImage(variant);
        this.updateVariantMetaField(variant);
        if (!variantFeaturedMediaId) return;
        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);
        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
